import { render } from "./Detail.vue?vue&type=template&id=1015e608&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=1015e608&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1015e608"

export default script